// extracted by mini-css-extract-plugin
module.exports = {"root":"az_BKc","hover":"az_CKc"};